import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CartItem,
  QuoteItem,
  QuoteItemStatus,
  QuoteSize,
  QuoteStatus,
  Workflow,
} from 'src/app/models';

@Injectable({
  providedIn: 'root',
})
export class QuoteHttpService {
  readonly http = inject(HttpClient);

  isInt(n): boolean {
    return n % 1 === 0;
  }

  intToFloat(n): string {
    // always returns float with 3 or more decimals
    if (this.isInt(n)) {
      return Number(n).toFixed(3); // example: 1 to 1.00
    } else if (new String(n).split('.')[1].length < 3) {
      return Number(n).toFixed(3); // example: 1.1 to 1.100
    } else {
      return n; // already float with 3 or more decimals
    }
  }

  public getWorkflowsByActionFilter(actionFilter) {
    return this.http.post<Workflow[]>('/quotes_action_filter', actionFilter);
  }

  // TODO - To be DELETED (not used)
  public getQuotes(showDeadStatus) {
    return this.http.get<Workflow[]>(`/quotes/${showDeadStatus}`);
  }

  // TODO - To be DELETED (not used)
  public getQuotesPaginated(page, payload) {
    return this.http.post(`/quotes_paginated?page=${page}`, payload);
  }

  public updateQuoteItemsActiveFlag(quote_items) {
    return this.http.put('/quote_items/toggle_active', quote_items);
  }

  // TODO - To be DELETED (not used)
  public getQuote(id) {
    return this.http.get<Workflow>(`/quote/${id}`);
  }

  // TODO - To be DELETED (not used)
  public getQuotePDF(id) {
    return this.http.get(`/quote_pdf/${id}`);
  }

  public sendQuoteMail(quoteMessage) {
    return this.http.post('/quote_mail', quoteMessage);
  }

  public createQuote(quote) {
    return this.http.post<Workflow>('/quotes', quote);
  }

  // TODO - To be DELETED (not used)
  public getQuoteSize(id) {
    return this.http.get<QuoteSize>(`/quote_item_size/${id}`);
  }

  public updateQuoteStatus(
    id,
    due_date,
    project_status,
    item_status,
    financial_status
  ) {
    return this.http.put(
      `/quote_update_status/${id}/${due_date}/${project_status}/${item_status}/${financial_status}`,
      ''
    );
  }

  public updateQuoteCoefDisc(
    id,
    coefficient,
    discount,
    adjust_quote_item_coef
  ) {
    return this.http.put(
      `/quote_update_coef_disc/${id}/${coefficient}/${this.intToFloat(discount)}/${adjust_quote_item_coef}`,
      ''
    );
  }

  public updateQuoteCoefDiscValue(id, discountNominal) {
    return this.http.put(
      `/quote_update_coef_disc_value/${id}/${discountNominal}`,
      ''
    );
  }

  public updateQuoteDiscStatus(id, status) {
    return this.http.put(`/quote_update_disc_status/${id}/${status}`, '');
  }

  public getQuoteItemsByQuote(id) {
    return this.http.get<QuoteItem[]>(`/quote_items_by_quote/${id}`);
  }

  public createQuoteItem(quote_item) {
    return this.http.post<QuoteItem>('/quote_items', quote_item);
  }

  public deleteQuoteItem(id) {
    return this.http.delete(`/quote_item/${id}`);
  }

  // TODO - To be DELETED (not used)
  public getQuoteStatuses() {
    return this.http.get<QuoteStatus[]>('/quote_statuses');
  }

  // TODO - To be DELETED (not used)
  public getQuoteItemStatuses() {
    return this.http.get<QuoteItemStatus[]>('/quote_item_statuses');
  }

  public updateQuoteItems(id: string, qty: string, item_status, coefficient) {
    return this.http.put<CartItem>(
      `/quote_item_qty/${id}/${qty}/${item_status}/${coefficient}`,
      ''
    );
  }

  public updateQuoteDueDate(id, due_date) {
    return this.http.put(`/quote_update_due_date/${id}/${due_date}`, '');
  }

  public updateQuoteItemSupplier(id, supplier) {
    return this.http.put<CartItem>(
      `/quote_item_supplier/${id}/${supplier}`,
      ''
    );
  }

  public createQuoteInvoice(
    financialSystemId,
    sourceId,
    discount,
    dueDate,
    paymentLink
  ) {
    return this.http.get(
      `/quote_create_invoice/${financialSystemId}/${sourceId}/${this.intToFloat(
        discount
      )}/${dueDate}/${paymentLink}`
    );
  }

  public updateQuoteInvoice(
    invoiceId,
    total_deposit,
    financialSystemId,
    sourceId,
    discount,
    dueDate,
    paymentLink
  ) {
    return this.http.get(
      `/quote_update_invoice/${invoiceId}/${total_deposit}/${financialSystemId}/${sourceId}/${this.intToFloat(
        discount
      )}/${dueDate}/${paymentLink}`
    );
  }

  public updateQuotePaymentInvoice(
    invoiceId,
    paid,
    financialSystemId,
    sourceId,
    discount
  ) {
    return this.http.get(
      `/quote_update_payment_invoice/${invoiceId}/${paid}/${financialSystemId}/${sourceId}/${this.intToFloat(discount)}`
    );
  }

  public getQuotesByCustomer(showDeadStatus, id) {
    return this.http.get<Workflow[]>(
      `/quotes_by_customer/${showDeadStatus}/${id}`
    );
  }

  public updateQuoteTotalPrice(quoteId, total_price) {
    return this.http.put(
      `/quote_update_total_price/${quoteId}/${total_price}`,
      ''
    );
  }

  //update individual item status per item quote-item
  public updateQuoteIItemStatus(quoteId, itemStatus) {
    return this.http.put(`/quote_item_status/${quoteId}/${itemStatus}`, '');
  }

  public updateQuoteItemStatus(quoteId, itemStatus) {
    return this.http.put(
      `/quote_update_item_status/${quoteId}/${itemStatus}`,
      ''
    );
  }

  public updateQuoteFinancialStatus(quoteId, financialStatus) {
    return this.http.put(
      `/quote_update_financial_status/${quoteId}/${financialStatus}`,
      ''
    );
  }

  // TODO - To be DELETED (not used)
  public updateQuoteNoItems(quoteId, noItems) {
    return this.http.put(`/quote_update_no_items/${quoteId}/${noItems}`, '');
  }

  public updateQuoteManagedBy(quoteId, userId) {
    return this.http.put(`/quote_update_managed_by/${quoteId}/${userId}`, '');
  }
}
